// extracted by mini-css-extract-plugin
export default {"title":"f5Tr1lsl"};